import React, { FunctionComponent } from 'react'
import { majorScale, Heading, Link, Paragraph } from 'evergreen-ui'
import MfaOption from './MfaOption'
import { MfaOptionTypes } from '../MfaApp'
import DialogLayout from './DialogLayout'
import LoadingPlaceholder from '../../../components/LoadingPlaceholder'
import ErrorComponent from '../../../components/ErrorComponent'

interface MfaMenuProps {
  configureTfaMethod: (option: MfaOptionTypes) => void
  isLoading: boolean
  isErrored: boolean
  isSmsEnabled: boolean | null
  isTotpEnabled: boolean | null
  lastFourPhone: string | null
}

const MfaMenu: FunctionComponent<MfaMenuProps> = ({
  isLoading,
  isErrored,
  isSmsEnabled,
  isTotpEnabled,
  lastFourPhone,
  configureTfaMethod
}) => (
  <DialogLayout>
    <Heading size={400} marginBottom={majorScale(1)}>
      Protect your account with Multi-Factor Authentication
    </Heading>
    <Paragraph marginBottom={majorScale(1)}>
      Each time you sign in to your Segment account, you’ll need your password and a verification code.{' '}
      <Link href="https://segment.com/docs/iam/mfa/" target="_blank">
        Learn more
      </Link>
    </Paragraph>
    <Paragraph>
      Make sure that you also enable multi-factor authentication for the email account that you use to log into Segment.
    </Paragraph>

    <Heading size={400} marginTop={majorScale(3)}>
      Multi-Factor Authentication options
    </Heading>

    {isErrored ? (
      <ErrorComponent
        componentName="MfaApp"
        messaging="Something went wrong and we weren't able to load your Multi-Factor Authentication settings."
        marginY="0"
        maxWidth="auto"
        marginTop={majorScale(2)}
      />
    ) : (
      <LoadingPlaceholder isLoading={isLoading} noPadding paddingY={majorScale(5)}>
        <MfaOption
          type={MfaOptionTypes.totp}
          isEnabled={isTotpEnabled}
          configureTfaMethod={configureTfaMethod}
          onDisableClick={() => configureTfaMethod(MfaOptionTypes.disableTotp)}
        />
        <MfaOption
          type={MfaOptionTypes.sms}
          isEnabled={isSmsEnabled}
          configureTfaMethod={configureTfaMethod}
          phoneNumber={lastFourPhone}
          onDisableClick={() => configureTfaMethod(MfaOptionTypes.disableSms)}
        />
      </LoadingPlaceholder>
    )}
  </DialogLayout>
)

export default MfaMenu
